import { Injectable } from "@angular/core";
import { Subject, ReplaySubject, Observable } from "rxjs";

interface MathJaxConfig {
  source: string;
  integrity: string;
  id: string;
}

declare global {
  interface Window {
    // MathJax: {
    //   typesetPromise: () => void;
    //   startup: {
    //     promise: Promise<any>;
    //   };
    // };
    MathJax:any;
  }
}

@Injectable({
  providedIn: "root"
})
export class MathMlService {
  private signal: Subject<boolean>;
  private mathJax: MathJaxConfig = {
    source: "https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-mml-chtml.js",
    integrity: "sha512-TVq6RFk599KMqPh7Ri0yEAxHbJ0dcxSSPgvMuzQUg0wu4z+X7z2PsibMbbzAq/AHloHdxMW0FdvKv9k4s8niuA==",
    id: "MathJax-script"
  };
  // private mathJaxFallback: MathJaxConfig = {
  //   source: "assets/mathjax/mml-chtml.js",
  //   integrity: "sha512-TVq6RFk599KMqPh7Ri0yEAxHbJ0dcxSSPgvMuzQUg0wu4z+X7z2PsibMbbzAq/AHloHdxMW0FdvKv9k4s8niuA==",
  //   id: "MathJaxBackupScript"
  // };

  constructor() {
    this.signal = new ReplaySubject<boolean>();
    void this.registerMathJaxAsync(this.mathJax)
      .then(() => this.signal.next())
      .catch(error => {
        // // void this.registerMathJaxAsync(this.mathJaxFallback)
        //   .then(() => this.signal.next())
        //   .catch((error) => console.log(error));
      });
  }

  private async registerMathJaxAsync(config: MathJaxConfig): Promise<any> {
    return new Promise<void>((resolve, reject) => {
      const script: HTMLScriptElement = document.createElement("script");
      //script.id = config.id;
      script.type = "text/javascript";
      script.src = config.source;
      //script.integrity = config.integrity;
      script.crossOrigin = "anonymous";
      script.async = true;
      script.onload = () => resolve();
      script.onerror = error => reject(error);
      document.head.appendChild(script);
    });
  }



  ready(): Observable<boolean> {
    return this.signal;
  }

  render(element: HTMLElement, math: string) {
    // Take initial typesetting which MathJax performs into account
    //console.log(window.MathJax,'window.MathJax');
    window.MathJax.startup.promise.then(() => {
      window.MathJax.typesetClear();
      element.innerHTML = math;
      window.MathJax.typesetPromise();
    });
  }
}
